import { ACTION_LOAD_CONFIG, ACTION_START_SESSION } from "./actionTypes";
import { ConfigState, EngagementPhase } from "../definitions";
import { addNotification, changeEngagementPhase } from "./genericActions";

import { Client } from "@twilio/conversations";
import { Dispatch } from "redux";
import { MESSAGES_LOAD_COUNT } from "../../constants";
import { initClientListeners } from "./listeners/clientListener";
import { initConversationListener } from "./listeners/conversationListener";
import { initMessagesListener } from "./listeners/messagesListener";
import { initParticipantsListener } from "./listeners/participantsListener";
import log from "loglevel";
import { notifications } from "../../notifications";

export function initConfig(config: ConfigState) {
    return {
        type: ACTION_LOAD_CONFIG,
        payload: config
    };
}

export function initSession({ token, conversationSid }: { token: string; conversationSid: string }) {
    return async (dispatch: Dispatch) => {
        let conversationsClient: Client;
        let conversation;
        let participants;
        let users;
        let messages;

        conversationsClient = await new Client(token);

        conversationsClient.on("connectionStateChanged", async (state) => {
            if (state === "connected") {
                try {
                    try {
                        conversation = await conversationsClient.getConversationBySid(conversationSid);
                    } catch (e) {
                        console.error(e)
                        dispatch(addNotification(notifications.failedToInitSessionNotification("Couldn't load conversation")));
                        dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
                        return;
                    }

                    participants = await conversation.getParticipants();
                    users = await Promise.all(participants.map(async (p) => p.getUser()));
                    messages = (await conversation.getMessages(MESSAGES_LOAD_COUNT)).items;
                } catch (e) {
                    log.error("Something went wrong when initializing session", e);
                    throw e;
                }

                dispatch({
                    type: ACTION_START_SESSION,
                    payload: {
                        token,
                        conversationSid,
                        conversationsClient,
                        conversation,
                        users,
                        participants,
                        messages,
                        conversationState: conversation.state?.current,
                        currentPhase: EngagementPhase.MessagingCanvas
                    }
                });

                initClientListeners(conversationsClient, dispatch);
                initConversationListener(conversation, dispatch);
                initMessagesListener(conversation, dispatch);
                initParticipantsListener(conversation, dispatch);
            }

        })

    };
}
